import React from "react";

import { Container } from "./styles";

export default function Home({ toggleTitles }) {
  toggleTitles("Dashboard", "");

  return <Container></Container>;
}
